<template>
  <div class="nominations" id="reportVEAwards">
    <ul class="list-group mb-4">
      <li v-if="nominations.length > 0" v-for="nomination in nominations" v-bind:key="nomination.id" class="list-group-item mb-4">
        <div class="d-sm-flex pt-2">
          <figure>
            <img  v-if="nomination.isteamaward && nomination.isteamaward[0] != 'true'" class="border border-secondary rounded" src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/06/generic-profile.png" width="120" height="120">
            <img  v-else class="border border-secondary rounded" src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/10/team-profile.png" width="120" height="120">
            <figcaption class="text-center small pt-1 font-weight-bold" v-if="nomination.isteamaward && nomination.isteamaward[0] != 'true'">
              <router-link :to="'/thinktank-user/' + nomination.nominee_slug[0]" target="_blank">{{nomination.nominee_name[0]}}</router-link><br>
              <!--<span class="text-secondary">insertCompany</span>-->
            </figcaption>
          </figure>
          <div class="pl-sm-4">
            <!--img class="float-right" :src="'static/' + nomination.author_country + '.svg'" width="50" height="33"-->
            <h4 v-html="nomination.title && nomination.title.rendered"></h4>
      			<h2 v-html="nomination.title && nomination.title.content"></h2>
            <ul class="list-inline">
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-user fa-fw"></i>
                  Nomination by:
                  <router-link :to="'/thinktank-user/' + nomination._embedded.author[0].slug" target="_blank">{{nomination._embedded.author[0].name}}</router-link>
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-address-card fa-fw"></i>
                  Staff no. {{nomination.nominator_details[0][0]['employee-number']}}
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-building fa-fw"></i>
                  {{nomination.nominator_details[0][0]['employee-company']}}
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-clock fa-fw"></i>
                  {{nomination.date.substring(0, 10)}}
                </small>
              </li>
            </ul>
            <hr>
            <div class="mb-2" v-if="nomination.isteamaward && nomination.isteamaward.length === 0">
              <strong>Nominee company:</strong><br>
              {{nomination.nominee_company[0]}}
            </div>
            <div v-html="nomination.content.rendered"></div>
            <router-link v-if="nomination.supporting_documentation.length > 0 && nomination.supporting_documentation[0] !== ''" :to="'/supporting-documentation/' + nomination.supporting_documentation[0]" target="_blank" class="btn btn-primary mb-3">View supporting documentation</router-link>
            <div v-if="(nomination.substantiation_comments.length > 0 && nomination.substantiation_comments[0] !== '') || (nomination.substantiation_references.length > 0 && nomination.substantiation_references[0] !== '')" class="substantiation">
              <h4>Substantiation by {{nomination.nominee_name[0]}}</h4>
              <p v-if="nomination.substantiation_comments.length > 0">
                <strong>Comments</strong>:<br>
                {{nomination.substantiation_comments[0]}}
              </p>
              <p v-if="nomination.substantiation_references.length > 0 && nomination.substantiation_references[0] !== ''">
                <strong>References</strong>:<br>
                {{nomination.substantiation_references[0]}}
              </p>
              Supporting document
              <div v-if="nomination.substantiation_documentation.length > 0 && nomination.supporting_documentation[0] !== ''">
                <router-link :to="'/supporting-documentation/' + nomination.substantiation_documentation[0]" target="_blank" class="btn btn-primary mb-3">View substantiation documentation</router-link>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: [
    'nominations'
  ],
  data () {
    return {
      nominationsWithCountry: []
    }
  },
  created () {
    this.nominationsWithCountry = this.nominations
    var behavior = ''
    for(let index = 0; index < this.nominations.length; index++) {
      behavior  = this.getBehavior(this.nominations[index])
      this.nominations[index].behavior = behavior
      console.log('getBehavior this.nominations ', this.nominations[index], this.nominations[index].bigups_ecards, ' behavior ', behavior, this.nominations[index].behavior)
    }
  },
  methods: {
    getBehavior: function (x) {
      if (x._embedded && x._embedded["wp:term"]) {
          const terms = x._embedded["wp:term"];
          if (terms.length > 0) {
              const lastTermsGroup = terms[terms.length - 1]
              let i = 0
              console.log('getBehavior  lastTermsGroup ', lastTermsGroup)
              for (i = 0; i < lastTermsGroup.length; i++) {
                if (lastTermsGroup[i].id > 106 && lastTermsGroup[i].id < 115) {
                    console.log('getBehavior  lastTermsGroup ', lastTermsGroup[i], lastTermsGroup[i].id)
                    return lastTermsGroup[i].name
                }
              }
          }
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NominationReportEntries.vue